import React, { Suspense, lazy, useEffect } from 'react';
import './App.css';
import './styles.css';
import { resetMapData, setDataList } from './redux/features/mapDataSlice';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { clearSearchItems } from './redux/features/searchSlice';

const AddDataElements = lazy(() => import('./add-data-elements/AddDataElements'));
const App = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  useEffect(() => {
    console.log(location);
    if (location && location.pathname) {
      const currentPath = location.pathname;
      dispatch(resetMapData());
      dispatch(clearSearchItems());
      dispatch(setDataList(currentPath));
    }
  }, [dispatch, location]);

  return (
    <>
      <Suspense fallback={<div className="container">Loading...</div>}>
        <AddDataElements />
      </Suspense>
    </>
  );
}

export default App;
